import { useEffect, useRef } from 'react'
import { useAnalytics } from 'use-analytics'

import { isNotNull, isNull } from '@hcr/utils'

import { useHoliday } from '../../../contexts'
import { useAccommodationDetailsQuery, useIdToken } from '../../../hooks'
import { createAccommodationContextChangedEvent } from '../../../utils'

export const useAccommodationContextChangeTracking = (): void => {
  const holiday = useHoliday()
  const idToken = useIdToken()
  const analytics = useAnalytics()
  const accommodationIdRef = useRef<number | null | undefined>(undefined)

  const accommodationDetails = useAccommodationDetailsQuery(
    { idToken: String(idToken), accommodationId: Number(holiday.data.accommodationId) },
    { enabled: isNotNull(holiday.data.accommodationId) && isNotNull(idToken) }
  )

  useEffect(() => {
    const trackAccommodationContextChange = () => {
      if (holiday.isSuccess && isNull(holiday.data.accommodationId) && isNotNull(accommodationIdRef.current)) {
        accommodationIdRef.current = null
        return analytics.track(...createAccommodationContextChangedEvent({ accommodationId: null }))
      }

      if (
        isNotNull(holiday.data.accommodationId) &&
        holiday.data.accommodationId !== accommodationIdRef.current &&
        accommodationDetails.isSuccess &&
        accommodationDetails.data
      ) {
        accommodationIdRef.current = holiday.data.accommodationId
        const accommodation = accommodationDetails.data
        return analytics.track(
          ...createAccommodationContextChangedEvent({
            accommodationId: accommodation.accommodation_id,
            resortId: accommodation.resort_id,
            fromDate: accommodation.start_date,
            toDate: accommodation.end_date,
          })
        )
      }
    }

    void trackAccommodationContextChange()
  }, [
    holiday.data.accommodationId,
    accommodationDetails.isSuccess,
    accommodationDetails.data,
    analytics,
    holiday.isSuccess,
  ])
}
